// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col, Button, Table } from 'react-bootstrap'
import { Link } from 'react-router'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { Message } from '../components/message'
import { AlertMessage } from '../components/alertMessage'
import config from '../config/config.json'

export class ManageInvites extends Component {
    constructor(props) {
        super(props)

        this.state = {
            invitedWorkers: [],
            success: false,
            error: false
        }

        this.init()
        this.getInvites(this.props.env, config)

        this.init = this.init.bind(this)
        this.loadInvitesListing = this.loadInvitesListing.bind(this)
        this.prepareInvitesListing = this.prepareInvitesListing.bind(this)
        this.handleInviteButtonClick = this.handleInviteButtonClick.bind(this)
        this.handleOnClickResendInvite = this.handleOnClickResendInvite.bind(this)
        this.createInviteList = this.createInviteList.bind(this)
        this.sendInvites = this.sendInvites.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    getInvites(env, config) {
        fetch(config[env] + config.api.list_invites.endpoint, {
            method: config.api.list_invites.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson)
                this.createInviteList(responseJson)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    createInviteList(invitations) {
        let invitationList = []

        invitations.forEach((invite, index) => {
            if (invite.worker_email.includes('[')) {

                JSON.parse(invite.worker_email).forEach(email => {
                    let cleanEmail = email.split("\r")[0]
                    if ((invitationList.indexOf(cleanEmail)) === -1) {
                        invitationList.push(cleanEmail)
                    }
                })
            }
            else {
                let cleanEmail = invite.worker_email.split("\r")[0]

                if ((invitationList.indexOf(cleanEmail)) === -1) {
                    invitationList.push(cleanEmail)
                }
            }
        })

        this.setState({
            invitedWorkers: invitationList
        })
    }

    prepareInvitesListing() {
        if (this.state.invitedWorkers.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="You have no pending invitations."
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (

                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        {this.loadInvitesListing()}
                    </Col>
                </Row>
            )
        }
    }

    loadInvitesListing() {
        return (
            <Table responsive>
                <thead>
                    <tr><th>S.No.</th><th>Email</th><th>Actions</th></tr>
                </thead>
                <tbody>
                    {this.loadInvitationData(this.state.invitedWorkers)}
                </tbody>
            </Table>
        )
    }

    loadInvitationData(invitedWorkers) {
        return invitedWorkers.map((invitation, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1 + "."}</td>
                    <td>{invitation}</td>
                    <td>
                        <label>
                            <Link to="#" data-workerEmail={invitation} onClick={this.handleOnClickResendInvite}>Resend Invite</Link>
                        </label>
                    </td>
                </tr>
            )
        })
    }

    handleInviteButtonClick(e) {
        e.preventDefault()

        this.props.router.push('/addWorker')
    }

    handleOnClickResendInvite(e) {
        e.preventDefault()

        this.setState({
            success: false,
            error: false
        })

        this.sendInvites(e.target.getAttribute('data-workerEmail'), this.props.env, config)
    }

    sendInvites(workerEmail, env, config) {
        let worker_connection = {
            "workers": [
                {
                    "first_name": "",
                    "last_name": "",
                    "email": workerEmail
                }
            ]
        }

        fetch(config[env] + config.api.connect_worker.endpoint, {
            method: config.api.connect_worker.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            },
            body: JSON.stringify(
                worker_connection: worker_connection
            )

        }).then((response) => response.json())
            .then((responseJson) => {
                ('errors' in responseJson || 'error' in responseJson) ? this.setState({ success: false, error: true }) : this.successfulInvitationSent(workerEmail[0])
            })
            .catch((error) => {
                console.error(error)
            })
    }

    successfulInvitationSent(workerEmail) {
        this.setState({
            success: true,
            error: false
        })
    }

    loadAlert() {
        if (this.state.success) {
            return (
                <AlertMessage
                    status="success"
                    message={"Invitation re-sent successfully!"}
                >
                </AlertMessage>
            )
        }
        else if (this.state.error) {
            return (
                <AlertMessage
                    status="danger"
                    message={"Re-sending invitation failed!!"}
                >
                </AlertMessage>
            )
        }
    }

    render() {
        let breadcrumb = (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)

        return (
            <div className="manage-invites-container page-container">

                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={2}
                />

                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                {breadcrumb}
                                <h2 className="title">Manage Invites</h2>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            {this.loadAlert()}
                        </Col>
                    </Row>
                    {this.prepareInvitesListing()}
                    <Row>
                        <Col smOffset={8} mdOffset={8} sm={3} md={3}>
                            <Button bsStyle="primary" onClick={this.handleInviteButtonClick}>Add Individual(s)</Button>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/manageInvites.js